import { IconButton, Tooltip, Card, CardHeader, Divider, Grid, Paper, Typography, Button, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { unitsApiKeyStore } from '../../../api/units-api-key-store';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { Icons } from '../../../assets/icons';
import { useFileDownload } from '../../../components/file-download';
import { LoadingIndicator } from '../../../components/loading-indicator.component';
import { PlanDetailsDialog } from '../../plan-library/plan-details/plan-details.dialog';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';

interface UnitEnergyStarDetails {
  unitData: any;
}
const UnitEnergyStarDetails = ({ unitData }: UnitEnergyStarDetails) => {
  const { downloadFile, isLoading: isLoadingFileDownload } = useFileDownload();

  const styling = {
    root: { borderRadius: '10px' },
    textColor: { color: '$primary-color' },
    headingStyle: { color: '#0000b5', paddingBottom: '10px' },
    labelStyle: { color: '#0000b5', fontSize: '14px' },
    valueStyle: { color: '#000', fontWeight: '500', fontSize: '13px' },
  };

  const handleDownloadFile = async (data: any) => {
    const value = {
      unitID: Number(unitData?.unitID) || 0,
      fileName: data?.hvacDesignFileName,
      fileType: data?.hvacDesignFileType,
    };
    downloadFile({ additionalData: value });
  };

  return (
    <Card elevation={0}>
      {isLoadingFileDownload && <LoadingIndicator isLoading={isLoadingFileDownload} />}
      <Paper elevation={0} style={{ padding: 20, borderRadius: '10px' }}>
        <Grid container>
          <Grid item xl={3} lg={3} sm={4} xs={6}>
            <FormGroup>
              <FormControlLabel disabled control={<Checkbox checked={unitData?.energyStar == true ? true : false} />} label="Energy Star" />
            </FormGroup>
          </Grid>
          {unitData?.energyStar && (
            <>
              <Grid item xl={3} lg={3} sm={4} xs={6}>
                <Typography className="d-flex flex-column mBm">
                  <label style={styling.labelStyle}>Airflow</label>
                  <span style={styling.valueStyle}>{!unitData?.airflow ? '---' : `${unitData?.airflow}`}</span>
                </Typography>
              </Grid>
              <Grid item xl={3} lg={3} sm={4} xs={6}>
                <Typography className="d-flex flex-column mBm">
                  <label style={styling.labelStyle}>HVAC Design File</label>
                  <span style={styling.valueStyle}>
                    {' '}
                    {!unitData?.hvacDesignFileName ? '---' : unitData?.hvacDesignFileName}
                    {!!unitData?.hvacDesignFileName && (
                      <GuardedComponent requiredPermissions={[UserPermissionName.DOWNLOAD_FILE]}>
                        <span>
                          <IconButton aria-label="download" onClick={() => handleDownloadFile(unitData)}>
                            <img src={Icons.FileDownload} alt="Download" />
                          </IconButton>
                        </span>
                      </GuardedComponent>
                    )}
                  </span>
                </Typography>
              </Grid>
              <Grid item xl={3} lg={3} sm={4} xs={6}>
                <Typography className="d-flex flex-column mBm">
                  <label style={styling.labelStyle}>HVAC Contractor</label>
                  <span style={styling.valueStyle}>
                    {!unitData?.hvacContractor ? '---' : `${unitData?.hvacContractor}`}
                  </span>
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      </Paper>
    </Card>
  );
};

export default UnitEnergyStarDetails;
